import React, { useEffect } from 'react';

import MaxWidth from '@/components/common/layout/MaxWidth';
import CityList from '@/components/locality-directory/CityList';
import CrossLinks from '@/components/locality-directory/CrossLinks';
import FeaturedLocalities from '@/components/locality-directory/FeaturedLocalities';
import Hero from '@/components/locality-directory/Hero';
import { trackEvent } from '@/services/track-event';

import css from './LocalityDirectoryTemplate.module.css';

const LocalityDirectoryTemplate = ({ content, title, sections }) => {
  const data = (sections && sections[0]) || {};

  const featured = data.featured || [];
  const cities = data.top || [];
  const general = data.general || [];

  useEffect(() => {
    trackEvent({
      event: 'Locality : Viewed page',
      pageType: 'Locality directory SRP',
    });
  }, []);

  return (
    <div className={css.localityDirectoryContainer}>
      <Hero title={title} />
      {content && content !== '' && (
        <MaxWidth>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </MaxWidth>
      )}
      <MaxWidth>
        <h2>Popular United States Cities</h2>
        <FeaturedLocalities featured={featured} />
      </MaxWidth>
      <MaxWidth>
        <h2>Top United States Cities</h2>
        <CityList cities={cities} />
      </MaxWidth>
      <MaxWidth>
        <h2>General RV Information</h2>
        <CrossLinks links={general} />
      </MaxWidth>
    </div>
  );
};

export default LocalityDirectoryTemplate;
